import React, { useEffect, useState } from 'react';
import './PreviewButton.css';
import Reviews from './Reviews';  // Correct path for local imports in the 'Views' folder
import SimilarAnime from './SimilarAnime'; // Import the SimilarAnime component


const PreviewButton = ({ animeId, onClose }) => {
  const [animeData, setAnimeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState([]);  // State to store reviews
  const [characters, setCharacters] = useState([]);  // State to store characters
  const [similarAnime, setSimilarAnime] = useState([]);  // State to store similar anime data


  // Fetch anime data, reviews, and characters on component mount or animeId change
  useEffect(() => {
    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  useEffect(() => {
    document.body.classList.add('body-no-scroll');

    const fetchAnimeDetails = async () => {
      try {
        const response = await fetch(`https://api.jikan.moe/v4/anime/${animeId}`);
        const data = await response.json();
        setAnimeData(data.data);
    
        const reviewsResponse = await fetch(`https://api.jikan.moe/v4/anime/${animeId}/reviews`);
        const reviewsData = await reviewsResponse.json();
    
        console.log('Fetched Reviews:', reviewsData); // Inspect the API response
        setReviews(reviewsData.data || []); // Ensure reviews is always an array
        
        const charactersResponse = await fetch(`https://api.jikan.moe/v4/anime/${animeId}/characters`);
        const charactersData = await charactersResponse.json();
        setCharacters(charactersData.data || []);
    

        const similarAnimeResponse = await fetch(`https://api.jikan.moe/v4/anime/${animeId}/recommendations`);
        const similarAnimeData = await similarAnimeResponse.json();
        setSimilarAnime(similarAnimeData.data || []); // Store similar anime recommendations
        setLoading(false);
      } catch (error) {
        console.error('Error fetching anime details:', error);
        setLoading(false);
      }
    };

    fetchAnimeDetails();

    return () => {
      document.body.classList.remove('body-no-scroll'); // Re-enable body scroll on cleanup
    };
  }, [animeId]);
  
  // Function to scroll through the reviews horizontally
  const scroll = (direction) => {
    const reviewsContainer = document.querySelector('.reviews-scroll');
    const scrollAmount = direction === 'left' ? -300 : 300;
    reviewsContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  };

  if (loading) {
    return (
      <div className="preview-overlay" onClick={onClose}>
        <div className="luxury-loader" onClick={(e) => e.stopPropagation()}>
          <div className="spinner"></div>
          <p className="loading-text">Loading...</p>
        </div>
      </div>
    );
  }

  if (!animeData) return null;

  return (
    <div className="preview-overlay" onClick={onClose}>
      <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          <span className="close-btn-icon">&times;</span>
          <span className="close-btn-text">Close</span>
        </button>

        <div className="header-container">
          <img src={animeData.images.jpg.image_url} alt={animeData.title} className="anime-image" />
          <div className="info-container">
            <h2 className="title-text">{animeData.title}</h2>
            <div className="summary-container">
  <span className="summary-item">Eps: {animeData.episodes || 'N/A'}</span>
  <span className="summary-item">Score: {animeData.score || 'N/A'}</span>
  <span className="summary-item">Rank: #{animeData.rank || 'N/A'}</span>
  <span className="summary-item">Popularity: #{animeData.popularity || 'N/A'}</span>
  <span className="summary-item">Favorites: {animeData.favorites || 'N/A'}</span>
</div>

          </div>
        </div>

        {/* Where to Watch Section */}
        {animeData.streaming && animeData.streaming.length > 0 && (
          <div className="watch-section">
            <h3 className="watch-title">Where to Watch</h3>
            <div className="watch-links">
              {animeData.streaming.map((platform, index) => (
                <a
                  key={index}
                  href={platform.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="watch-link-btn"
                >
                  <span className="watch-play-icon">&#9654;</span>
                  {platform.name}
                </a>
              ))}
            </div>
          </div>
        )}

        {/* MAL Link as fallback */}
        {(!animeData.streaming || animeData.streaming.length === 0) && animeData.url && (
          <div className="watch-section">
            <h3 className="watch-title">Watch & Learn More</h3>
            <div className="watch-links">
              <a
                href={animeData.url}
                target="_blank"
                rel="noopener noreferrer"
                className="watch-link-btn watch-link-mal"
              >
                <span className="watch-play-icon">&#9654;</span>
                MyAnimeList
              </a>
            </div>
          </div>
        )}

        <div className="details-container">
          <p className="air-date-text">Air Dates: {animeData.aired.string}</p>
          <p className="rating-text">Rating: {animeData.rating}</p>
          <p className="synopsis-text">{animeData.synopsis}</p>
        </div>

        {animeData.trailer.url && (
          <div className="trailer-container">
            <h3 className="trailer-title">Trailer</h3>
            <iframe
              className="trailer-iframe"
              width="100%"
              height="315"
              src={animeData.trailer.embed_url}
              title="Anime Trailer"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}

        <div className="genres-container">
          {animeData.genres.map(genre => (
            <span key={genre.mal_id} className="genre-tag luxury-hover">
              {genre.name}
            </span>
          ))}
        </div>

        {/* Character Section */}
        {/* Character Section */}
<h3 className="section-title">Main Characters</h3>
<div className="square-shapes-container">
  {characters.slice(0, 25).map((character) => (
    <div key={character.character.mal_id} className="character-card">
      {/* Role Tag */}
      <span className={`role-tag ${character.role.toLowerCase()}`}>
        {character.role} 
      </span>
      {/* Character Image */}
      <img
        src={character.character.images.jpg.image_url || 'https://via.placeholder.com/150'}
        alt={character.character.name} 
        className="character-image"
      />
      {/* Character Info */}
      <div className="character-info">
      <div className="character-name">{character.character.name}</div>
      </div>
    </div>
  ))}
</div>

{/* Reviews Section */}
<h3 className="section-title">Reviews</h3>
<div className="reviews-container-wrapper">
  <div className="scroll-buttons">
    <button className="scroll-btn left" onClick={() => scroll('left')}>
      &#10094; {/* Left Arrow */}
    </button>
    <button className="scroll-btn right" onClick={() => scroll('right')}>
      &#10095; {/* Right Arrow */}
    </button>
  </div>
  <Reviews reviews={reviews} />
</div>      
        
        {/* Similar Anime Section */}
        <h3 className="section-title">More Anime Like This</h3>
        <SimilarAnime animeId={animeData.mal_id} /> {/* Passing animeId to SimilarAnime */}
      </div>
    </div>
  );
};

export default PreviewButton;